/**
 * Mixin with invites functionality
 */

import TableMovementInviteMixin from "@/components/DigitalEvent/RoomList/Room/mixins/Invite/TableMovementInviteMixin";
import VideoCallInviteMixin from "@/components/DigitalEvent/RoomList/Room/mixins/Invite/VideoCallInviteMixin";
import { INVITE_STATUSES, INVITE_TYPES } from "@/helpers/constants";

export default {
  mixins: [TableMovementInviteMixin, VideoCallInviteMixin],
  computed: {
    /**
     * Invite Types
     * @return {Object}
     */
    inviteTypes() {
      return INVITE_TYPES;
    },

    /**
     * Invite statuses
     * @return {Object}
     */
    inviteStatuses() {
      return INVITE_STATUSES;
    },

    /**
     * Sent invites
     * @return {Object}
     */
    sentInvites() {
      return this.$store.state.invites.sentInvites;
    },

    /**
     * Sent invites users map
     * @return {Object}
     */
    sentInvitesUsersMap() {
      return this.$store.state.invites.sentInvitesUsersMap;
    },

    /**
     * Received invites
     * @return {Array}
     */
    receivedInvites() {
      return this.$store.state.invites.receivedInvites;
    },

    /**
     * Displaying Received invites
     * @return {Array}
     */
    displayingReceivedInvites() {
      return this.$store.state.invites.displayingReceivedInvites;
    }
  },
  methods: {
    /**
     * Show received invites
     * @param invites {Array}
     */
    showReceivedInvites(invites) {
      invites.forEach(async invite => {
        if (invite && !this.displayingReceivedInvites[invite.uuid]) {
          await this.showReceivedInvite(invite);
        }
      });
    },

    /**
     * Show received invite
     * @param invite {Object}
     */
    async showReceivedInvite(invite) {
      if (invite.inviteType === INVITE_TYPES.TABLE_MOVEMENT) {
        await this.showTableMovementInvite(invite);
      }

      if (invite.inviteType === INVITE_TYPES.VIDEO_CALL) {
        await this.showVideoCallInvite(invite);
      }
    },

    /**
     * Hide invite announce and remove it from the state
     * @param invite {Object}
     */
    hideInvite(invite) {
      this.$store.commit("invites/deleteDisplayingInvite", invite);
      this.$store.commit("invites/deleteReceivedInvite", invite);
    }
  }
};
